<template src="./DragNormalComponent.html"></template>
<script>
import draggable from 'vuedraggable';

export default {
  name: 'DragNormalComponent',
  components: {
    draggable
  },
  props: {
    listItems: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup(props) {
    const listItemsCurrent = props.listItems

    function onDrop(event) {
    }
    return {
      listItemsCurrent,
      onDrop
    }
  }
}
</script>
<style scoped></style>
